import { Typography } from '@eventbrite/marmalade';
import { FormattedMessage } from 'react-intl';
import styles from './ToBeAnnouncedLocation.module.scss';

export const ToBeAnnouncedLocation: React.FC = () => {
  return (
    <div className={styles.toBeAnnouncedLocation}>
      <Typography as="p" className={styles.text}>
        <FormattedMessage
          id="To be announced"
          defaultMessage="To be announced"
          description="Location to be announced text"
        />
      </Typography>
    </div>
  );
};
